import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  go() {
    if (/^https?:\/\//.test(this.urlValue)) {
      window.open(this.urlValue, "_blank", "noopener,noreferrer")
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
